import React, { useEffect, useState } from "react";
import {
  roles,
  riderRoles,
  cashierRoles,
  accountantRoles,
  productManagerRoles,
  systemUserRoles,
  displayUserRoles,
} from "../../config/config";

const Checkbox = ({ label, value, isChecked, onChange }) => {
  return (
    <div className="flex items-center mr-4">
      <label className="relative flex items-center px-3 rounded-full cursor-pointer">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          value={value}
          className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-d-bg checked:bg-d-bg checked:before:bg-d-bg hover:before:opacity-10"
        />
        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3.5 w-3.5"
            viewBox="0 0 20 20"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
        </span>
      </label>
      {label}
    </div>
  );
};

const SelectAllCheckbox = ({
  handleModuleAccesSelect,
  role,
  module_access,
}) => {
  const modulesAccess = JSON.parse(module_access);
  const [checkboxes, setCheckboxes] = useState(modulesAccess);
  const [selectAll, setSelectAll] = useState(false);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setCheckboxes([...checkboxes, e.target.value]);
    } else {
      setCheckboxes(checkboxes.filter((item) => item !== e.target.value));
      setSelectAll(false);
    }
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    let updatedCheckboxes = [];

    if (isChecked) {
      updatedCheckboxes = roles.map((role) => role.value);
    }

    setCheckboxes(updatedCheckboxes);
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    handleModuleAccesSelect(checkboxes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkboxes]);

  useEffect(() => {
    setSelectAll(false);
    if (modulesAccess.length >= 0) {
      var modules = [];
      if (role === "super-admin") {
        modules = systemUserRoles;
        setSelectAll(true);
      } else {
        if (role === "cashier") modules = cashierRoles;
        if (role === "rider") modules = riderRoles;
        if (role === "display_user") modules = displayUserRoles;
        if (role === "accountant") modules = accountantRoles;
        if (role === "product_manager") modules = productManagerRoles;
      }
    }

    setCheckboxes(modules || modulesAccess);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  return (
    <div>
      <div className="flex items-center mr-4">
        <label className="relative flex items-center px-3 rounded-full cursor-pointer">
          <input
            type="checkbox"
            checked={selectAll}
            onChange={handleSelectAllChange}
            className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-d-bg checked:bg-d-bg checked:before:bg-d-bg hover:before:opacity-10"
          />
          <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-3.5 w-3.5"
              viewBox="0 0 20 20"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="1"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              ></path>
            </svg>
          </span>
        </label>
        Select All
      </div>
      <div className="mt-4 grid gap-4 grid-cols-2">
        {roles.map((role, index) => (
          <div className="" key={index}>
            <Checkbox
              label={role.label}
              value={role.value}
              isChecked={checkboxes.includes(role.value)}
              onChange={handleCheckboxChange}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectAllCheckbox;
